import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, InputTypeToken, SizeTypeTokens, StackHeight, StackType, StackWidth, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { navigateCustomerJourney, navigateToCustomerFilterScreen, navigateToCustomerScreen, navigateToInterestCalculatorScreen, navigateToInterestFilterScreen, navigateToInterestScreen, navigateToRenewalFilterScreen, navigateToRenewalScreen, navigateToShortfallFilterScreen, navigateToShortfallScreen, onChangeTab, onLoadActiveCustomer, onRegisterLeads, onSearchActiveCustomer, onShareLinkWithCustomer, onSortActiveCustomer, onTrackCustomerJourney, viewCustomerDetails, viewDetails } from "./actions";
import _ from "lodash";
import { SideBarBuilderDS } from "../sideNavBar";
import sharedPropsService from "../../SharedPropsService";
import SharedPropsService from "../../SharedPropsService";
import { api, partnerApi, StoreKey } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { CreditApplicationState, PARTNER_CACHE_EXPIRE_TIME } from "../../configs/constants";
import { ActiveCustomerTableBuilder, navigateByUrl, ShowNewRmContactButton } from "../partnerWeb_Dashboard/utils";
import { addMinutesToCurrentTimeStamp, appendURlWithParam, isMobile, setAppHeader, showNewDashboardFlow } from "../../configs/utils";
import { PartnerHeader } from "../partnerWeb_Dashboard/partnerHeader";
import { GoToFaq, GoToHome, GoToPhone, GoToWhatsapp } from "../partnerSignUp/actions";
import { handleConnection, onLogoutPress, openMenu } from "../partnerWeb_Dashboard/actions";
import { BottomNavBuilderDS } from "../bottomNav";
import { ActiveCustomerMobStack } from "./indexMob";
import { ActiveCustomerMobEmptyStateStack } from "./indexMobEmptyState";
import AsyncStorage from "@react-native-async-storage/async-storage";
const _isMobile = isMobile();
export const template = async (partnerActiveCustomerData, partnerAccountType, user, showNewRmContactButton, rmData, showNewCustomerDashboard, height, currentActiveTabIndex, customerResponse, tabData, currentPageCustomer, totalNoOfPages, actualPageSizeCustomer, customerDataFetched, showDashboardCard, numberOfFilterApplied, filterObj, isFromMobile) => ({
    layout: {
        id: ROUTE.PARTNER_ACTIVE_CUSTOMER,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            showNewRmContactButton ? { id: 'rmContactButton', type: WIDGET.RM_CONTACT_LIST, position: POSITION.ABSOLUTE_BOTTOM } : {},
            isFromMobile ? {} : { id: 'sideNav', type: WIDGET.STACK, position: POSITION.NAVBAR_LEFT },
            (isFromMobile) ? { id: 'activeCustomerMobRootStack', type: WIDGET.STACK } : {
                id: 'activeCustomerPageRootStack',
                type: WIDGET.STACK
            },
            showNewCustomerDashboard === true && isFromMobile ? { id: 'customerDetailsTable', type: WIDGET.CUSTOMER_MOB_DETAILS } : {},
            isFromMobile ? { id: 'BottomNavContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {}
        ],
    },
    datastore: {
        rmContactButton: {
            title: 'Contact us',
            rmData,
            handleRmConnection: {
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                type: ACTION.HANDLE_CONNECTION,
                payload: {}
            }
        },
        ...(await PartnerHeader(ROUTE.PARTNER_ACTIVE_CUSTOMER, undefined, user)),
        ...await SideBarBuilderDS(ROUTE.PARTNER_ACTIVE_CUSTOMER),
        ...await BottomNavBuilderDS(ROUTE.PARTNER_ACTIVE_CUSTOMER),
        ...showNewCustomerDashboard === false && await ActiveCustomerMobStack(partnerActiveCustomerData?.customerMetadataList, partnerAccountType),
        activeCustomerPageRootStack: {
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.MATCH_PARENT,
            type: StackType.column,
            flex: 1,
            padding: {
                top: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                right: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
            },
            widgetItems: showNewCustomerDashboard === true ? [{ id: 'customerDetailsTable', type: WIDGET.CUSTOMER_DETAILS_TABLE }] :
                partnerActiveCustomerData?.customerMetadataList.length > 0
                    ? [
                        { id: 'activeCustomerCountText', type: WIDGET.TEXT },
                        { id: 'activeCustomerCountText2', type: WIDGET.TEXT },
                        { id: 'activeCustomerspace0', type: WIDGET.SPACE },
                        { id: 'activeCustomertopStack', type: WIDGET.STACK },
                        // { id: 'activeCustomerspace1', type: WIDGET.SPACE },
                        // { id: 'noDataMessageAC', type: WIDGET.MESSAGE},
                        { id: 'activeCustomerspace2', type: WIDGET.SPACE },
                        { id: 'activeCustomerTable', type: WIDGET.TABLE },
                    ]
                    : [
                        { id: 'activeCustomerCountText', type: WIDGET.TEXT },
                        { id: 'activeCustomerCountText2', type: WIDGET.TEXT },
                        { id: 'activeCustomerMobEmptyStateStack', type: WIDGET.STACK }
                    ],
        },
        customerDetailsTable: {
            height: height - 94,
            activeTab: currentActiveTabIndex,
            showDashboardCard,
            numberOfFilterApplied,
            filterObj,
            navigateToCustomerScreen: {
                type: ACTION.VIEW_CUSTOMER_SCREEN,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToShortfallScreen: {
                type: ACTION.VIEW_SHORTFALL_SCREEN,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToInterestScreen: {
                type: ACTION.VIEW_INTEREST_SCREEN,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToRenewalScreen: {
                type: ACTION.VIEW_RENEWAL_SCREEN,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToCustomerScreenDebounce: {
                type: ACTION.VIEW_CUSTOMER_SCREEN_DEBOUNCE,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToShortfallScreenDebounce: {
                type: ACTION.VIEW_SHORTFALL_SCREEN_DEBOUNCE,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToInterestScreenDebounce: {
                type: ACTION.VIEW_INTEREST_SCREEN_DEBOUNCE,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToRenewalScreenDebounce: {
                type: ACTION.VIEW_RENEWAL_SCREEN_DEBOUNCE,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToInterestFilter: {
                type: ACTION.INTEREST_FILTER,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToCustomerFilter: {
                type: ACTION.CUSTOMER_FILTER,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToRenewalFilter: {
                type: ACTION.RENEWAL_FILTER,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToShortfallFilter: {
                type: ACTION.SHORTFALL_FILTER,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToCustomerDetails: {
                type: ACTION.VIEW_CUSTOMER_DETAILS,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToCustomerJourney: {
                type: ACTION.VIEW_CUSTOMER_JOURNEY,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToShareLink: {
                type: ACTION.SHARE_LINK_REF,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            navigateToInterestCalculator: {
                type: ACTION.NAVIGATE_INTEREST_CAL_SCREEN,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {},
            },
            currentPageCustomer: currentPageCustomer,
            actualPageSizeCustomer: actualPageSizeCustomer,
            totalNoOfPages: totalNoOfPages,
            customerData: customerResponse,
            interestData: [],
            renewalData: [],
            shortfallData: [],
            tabData,
            dataFetched: customerDataFetched,
            counter: 0,
        },
        ...await ActiveCustomerMobEmptyStateStack(partnerAccountType, user),
        activeCustomerCountText: {
            label: `Completed applications`,
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.LG,
            fontWeight: '600',
            lineHeight: 26,
        },
        activeCustomerCountText2: {
            label: `Track your completed applications`,
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Charcoal,
            fontWeight: '400',
            lineHeight: 20,
        },
        activeCustomerTable: {
            numOfCol: partnerActiveCustomerData?.customerMetadataList
                ? partnerActiveCustomerData?.customerMetadataList.length
                : 0,
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.MATCH_PARENT,
            titleMap: {
                ...ActiveCustomerTableBuilder(partnerActiveCustomerData?.customerMetadataList, partnerAccountType).Title_MAP,
            },
            titleConfig: {
                ...ActiveCustomerTableBuilder(partnerActiveCustomerData?.customerMetadataList, partnerAccountType).TITLE_CONFIG,
            },
            // data: {
            //     name: [{id: 'name1', type: WIDGET.TEXT}, {id: 'name2', type: WIDGET.TEXT}, {id: 'name3', type: WIDGET.TEXT}],
            //     pan: [{id: 'pan1', type: WIDGET.TEXT}, {id: 'pan2', type: WIDGET.TEXT}, {id: 'pan3', type: WIDGET.TEXT}],
            //     mobile: [{id: 'mobile1', type: WIDGET.TEXT}, {id: 'mobile2', type: WIDGET.TEXT}, {id: 'mobile3', type: WIDGET.TEXT}],
            //     email: [{id: 'email1', type: WIDGET.TEXT}, {id: 'email2', type: WIDGET.TEXT}, {id: 'email3', type: WIDGET.TEXT}],
            //  }
            widgetData: {
                ...ActiveCustomerTableBuilder(partnerActiveCustomerData?.customerMetadataList, partnerAccountType).DATA,
            },
            data: partnerActiveCustomerData?.customerMetadataList,
            sortAction: {
                type: ACTION.ON_SORT_AC,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {
                    value: '',
                    partnerAccountType: partnerAccountType
                },
            },
            // selected: true,
            // allSelectedAction: {
            //     type: ACTION.ON_SELECT_ALL_LEADS,
            //     routeId: ROUTE.PARTNER_DASHBOARD,
            //     payload: {
            //
            //     }
            // }
        },
        ...ActiveCustomerTableBuilder(partnerActiveCustomerData?.customerMetadataList, partnerAccountType)
            .DATA_STORE,
        activeCustomertopStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'activeCustomerSearchStackLeft', type: WIDGET.STACK },
                { id: 'activeCustomerSearchStackRight', type: WIDGET.STACK },
            ],
        },
        activeCustomerSearchStackLeft: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            flex: 1,
            widgetItems: [
                { id: 'activeCustomerSeachInput', type: WIDGET.INPUT },
            ],
        },
        activeCustomerSearchStackRight: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            flex: 2,
            widgetItems: [],
        },
        activeCustomerSeachInput: {
            title: 'Search applications',
            value: '',
            placeholder: 'Search by name and phone number',
            type: InputTypeToken.DEFAULT,
            action: {
                type: ACTION.ON_SEARCH_AC,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {
                    value: '',
                    widgetId: 'activeCustomerSeachInput',
                    partnerAccountType: partnerAccountType
                },
            },
        },
        // noDataMessageAC: <MessageProps>{
        //       label: 'Sorry, but nothing match your search term',
        //       icon: <IconProps>{
        //         name: IconTokens.Info,
        //         size: IconSizeTokens.SM,
        //         color: ColorTokens.Grey_Charcoal,
        //       },
        //       labelColor: ColorTokens.Grey_Charcoal,
        //       bgColor: ColorTokens.Grey_Milk_1,
        // },
        activeCustomerspace0: { size: SizeTypeTokens.XXXL },
        activeCustomerspace1: { size: SizeTypeTokens.LG },
        activeCustomerspace2: { size: SizeTypeTokens.LG },
    }
});
export const PartnerActiveCustomerMF = {
    onLoad: async ({ openNewTab, asyncStorage, network, instrumentTrack, navigate, getHeight, ...props }, { setIsUserLoggedIn: boolean, actionItems, currentActiveTabIndex, dataFiltered, currentPageCutomerFiltered, pageSizeCustomerFiltered, actualPageSizeCustomerFiltered, customerDataFiltered, showDashboardCard, totalPagesFiltered, numberOfFilterApplied, filterObj, }) => {
        let currentActiveTab = 'customer';
        if (currentActiveTabIndex !== undefined) {
            if (currentActiveTabIndex === 1) {
                currentActiveTab = 'interest';
            }
            else if (currentActiveTabIndex === 2) {
                currentActiveTab = 'renewal';
            }
            else if (currentActiveTabIndex === 3) {
                currentActiveTab = 'shortfall';
            }
            else
                currentActiveTab = 'customer';
        }
        let getActiveIndexTab = await AsyncStorage?.getItem("activeIndexTab");
        if (getActiveIndexTab === 'interest' || getActiveIndexTab === 'renewal' || getActiveIndexTab === 'shortfall' || getActiveIndexTab === 'all') {
            currentActiveTab = getActiveIndexTab;
            if (getActiveIndexTab === 'interest') {
                currentActiveTabIndex = 1;
                currentActiveTab = 'interest';
            }
            else if (getActiveIndexTab === 'renewal') {
                currentActiveTabIndex = 2;
                currentActiveTab = 'renewal';
            }
            else if (getActiveIndexTab === 'shortfall') {
                currentActiveTabIndex = 3;
                currentActiveTab = 'shortfall';
            }
            else {
                currentActiveTabIndex = 0;
                currentActiveTab = 'customer';
            }
        }
        appendURlWithParam('customer');
        // --- Need refactor ---- //
        await setAppHeader();
        const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
        const token = await asyncStorage.get(StoreKey.accessToken);
        const dashboardActiveId = localStorage.getItem('DASHBOARD_ACTIVE_ID');
        await SharedPropsService.setToken(token);
        await sharedPropsService.setUser(user);
        const partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
        const authToken = await SharedPropsService.getToken();
        await sharedPropsService.setPartnerSideBarActiveId(dashboardActiveId);
        const partnerAccountType = user?.linkedPartnerAccounts[0].partnerAccountType;
        const accessToken = await asyncStorage.get(StoreKey.accessToken);
        if (!accessToken) {
            await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab, true);
            return;
        }
        // ---- //
        console.log('auth token: ', authToken);
        const isFromMobile = isMobile();
        let partnerActiveCustomerData = {
            customerMetadataList: [],
            nextToken: null
        };
        const currentTimeStamp = Date.now().valueOf();
        const cacheExpireTime = await sharedPropsService.getPartnerCacheExpireTime();
        const partnerActiveCustomerDataSharedPropsService = await sharedPropsService.getPartnerActiveCustomerList();
        let showNewCustomerDashboard = false;
        if (user === undefined || user === null) {
            const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
            showNewCustomerDashboard = await showNewDashboardFlow(userContextResponse?.data);
        }
        else {
            showNewCustomerDashboard = await showNewDashboardFlow(user);
        }
        //if cache data is empty then call from network
        if (showNewCustomerDashboard === false &&
            (partnerActiveCustomerDataSharedPropsService.customerMetadataList.length === 0 ||
                currentTimeStamp > cacheExpireTime.ActiveCustomerCacheExpireTime)) {
            const response = await network.get(`${partnerApi.clientList}${partnerAccountId}/customers/all`, {
                headers: await getAppHeader(),
            }, async () => {
            }, {
                isPartnerPlatform: true
            });
            if (response.status === 200) {
                partnerActiveCustomerData['customerMetadataList'] = response?.data?.customerMetadataList.filter((item, index) => {
                    if (item?.creditApplication?.applicationState === CreditApplicationState.COMPLETED) {
                        return true;
                    }
                    return false;
                });
                await sharedPropsService.setPartnerActiveCustomerList(partnerActiveCustomerData);
                await sharedPropsService.setPartnerCacheExpireTime({
                    ...cacheExpireTime,
                    ActiveCustomerCacheExpireTime: addMinutesToCurrentTimeStamp(PARTNER_CACHE_EXPIRE_TIME)
                });
            }
            else {
                // await clearAllData();
                // await partnerNavigate(ROUTE.PARTNER_SIGNUP);
            }
        }
        else {
            partnerActiveCustomerData = await sharedPropsService.getPartnerActiveCustomerList();
        }
        const PLJ_borrowerAccountId = await asyncStorage.get(StoreKey.PLJ_borrowerAccountId);
        if (PLJ_borrowerAccountId && PLJ_borrowerAccountId !== '') {
            await navigate(ROUTE.VOLT_APP);
        }
        const activeWidgetID = await SharedPropsService.getPartnerSideBarActiveId();
        console.log("activeWidgetID: ", activeWidgetID);
        instrumentTrack("CUSTOMER_PAGE_VIEWED");
        let showNewRmContactButton = false;
        showNewRmContactButton = await ShowNewRmContactButton();
        const header = await getAppHeader();
        const rmContactResponse = await network.get(`${partnerApi.getMappedRMDetails}${partnerAccountId}`, {
            headers: header
        });
        const rmData = rmContactResponse?.data;
        let customerResponse = [];
        let currentPageCustomer = 0;
        let actualPageSizeCustomer = 0;
        let customerDataFetched = false;
        let totalNoOfPages = 0;
        const tabData = [
            { label: "All customer", count: 0 },
            { label: "Interest due", count: 0 },
            { label: "Renewal due", count: 0 },
            { label: "Shortfall", count: 0 },
        ];
        if (showNewCustomerDashboard === true && dataFiltered === true) {
            customerResponse = customerDataFiltered;
            currentPageCustomer = currentPageCutomerFiltered;
            actualPageSizeCustomer = actualPageSizeCustomerFiltered;
            customerDataFetched = true;
            totalNoOfPages = totalPagesFiltered;
            const activeCustomerCountResponse = await network.get(`${partnerApi.getActiveCustomerCount}${partnerAccountId}/partnerdashboard/count`, {
                headers: header
            });
            if (activeCustomerCountResponse?.status === 200) {
                tabData[0].count = activeCustomerCountResponse?.data?.allCustomerCount || 0;
                tabData[1].count = activeCustomerCountResponse?.data?.interestDueCount || 0;
                tabData[2].count = activeCustomerCountResponse?.data?.renewalPendingCount || 0;
                tabData[3].count = activeCustomerCountResponse?.data?.shortfallCount || 0;
            }
        }
        else if (showNewCustomerDashboard === true) {
            const pageNumber = 1;
            let customerObject = {};
            let dynamicLink = 'partnerdashboard/all';
            if (currentActiveTabIndex !== undefined) {
                if (currentActiveTabIndex === 1) {
                    dynamicLink = 'partnerdashboard/interestDue';
                }
                else if (currentActiveTabIndex === 2) {
                    dynamicLink = 'partnerdashboard/renewal';
                }
                else if (currentActiveTabIndex === 3) {
                    dynamicLink = 'partnerdashboard/shortfall';
                }
                else
                    dynamicLink = 'partnerdashboard/all';
            }
            const response = await network.post(`${partnerApi.getAllCustomerList}${partnerAccountId}/${dynamicLink}/${pageNumber}`, customerObject, {
                headers: await getAppHeader(),
            }, async () => { return; }, { isPartnerPlatform: true });
            if (response.status === 200) {
                customerResponse = response?.data?.data;
                currentPageCustomer = response?.data?.currentPage;
                actualPageSizeCustomer = response?.data?.actualpageSize;
                customerDataFetched = true;
                totalNoOfPages = response?.data?.totalPages;
            }
            const activeCustomerCountResponse = await network.get(`${partnerApi.getActiveCustomerCount}${partnerAccountId}/partnerdashboard/count`, {
                headers: header
            });
            if (activeCustomerCountResponse?.status === 200) {
                tabData[0].count = activeCustomerCountResponse?.data?.allCustomerCount || 0;
                tabData[1].count = activeCustomerCountResponse?.data?.interestDueCount || 0;
                tabData[2].count = activeCustomerCountResponse?.data?.renewalPendingCount || 0;
                tabData[3].count = activeCustomerCountResponse?.data?.shortfallCount || 0;
            }
        }
        await AsyncStorage.setItem("activeIndexTab", undefined);
        return Promise.resolve(template(partnerActiveCustomerData, partnerAccountType, user, showNewRmContactButton, rmData, showNewCustomerDashboard, getHeight(), currentActiveTabIndex, customerResponse, tabData, currentPageCustomer, totalNoOfPages, actualPageSizeCustomer, customerDataFetched, showDashboardCard, numberOfFilterApplied, filterObj, isFromMobile));
    },
    actions: {
        [ACTION.ON_SEARCH_AC]: onSearchActiveCustomer,
        [ACTION.ON_LOAD]: onLoadActiveCustomer,
        [ACTION.ON_SORT_AC]: onSortActiveCustomer,
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.ON_TRACK_CUSTOMER_JOURNEY]: onTrackCustomerJourney,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.VIEW_DETAILS]: viewDetails,
        [ACTION.SHARE_LINK_REF]: onShareLinkWithCustomer,
        [ACTION.ON_REGISTER_LEADS]: onRegisterLeads,
        [ACTION.HANDLE_CONNECTION]: handleConnection,
        [ACTION.INTEREST_FILTER]: navigateToInterestFilterScreen,
        [ACTION.CUSTOMER_FILTER]: navigateToCustomerFilterScreen,
        [ACTION.RENEWAL_FILTER]: navigateToRenewalFilterScreen,
        [ACTION.SHORTFALL_FILTER]: navigateToShortfallFilterScreen,
        [ACTION.VIEW_CUSTOMER_DETAILS]: viewCustomerDetails,
        [ACTION.VIEW_CUSTOMER_JOURNEY]: navigateCustomerJourney,
        [ACTION.VIEW_CUSTOMER_SCREEN_DEBOUNCE]: _.debounce(navigateToCustomerScreen, 250),
        [ACTION.VIEW_RENEWAL_SCREEN_DEBOUNCE]: _.debounce(navigateToRenewalScreen, 250),
        [ACTION.VIEW_INTEREST_SCREEN_DEBOUNCE]: _.debounce(navigateToInterestScreen, 250),
        [ACTION.VIEW_SHORTFALL_SCREEN_DEBOUNCE]: _.debounce(navigateToShortfallScreen, 250),
        [ACTION.VIEW_CUSTOMER_SCREEN]: navigateToCustomerScreen,
        [ACTION.VIEW_RENEWAL_SCREEN]: navigateToRenewalScreen,
        [ACTION.VIEW_INTEREST_SCREEN]: navigateToInterestScreen,
        [ACTION.VIEW_SHORTFALL_SCREEN]: navigateToShortfallScreen,
        [ACTION.NAVIGATE_INTEREST_CAL_SCREEN]: navigateToInterestCalculatorScreen,
    },
    action: {
        routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
        type: ACTION.ON_LOAD,
        payload: {}
    },
};
